export const formatDateToTime = (date: number | Date) => {
  const formattedDate = new Date(date);

  return (
    formattedDate.getHours().toString().padStart(2, '0') +
    ':' +
    formattedDate.getMinutes().toString().padStart(2, '0')
  );
};

export const formatDateToLocaleDate = (date: Date) => {
  return new Date(date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    weekday: 'short',
  });
};

export const timeToUtc = (time: string) => {
  const offset = new Date().getTimezoneOffset() * 60000;
  const splitedTime = time.split(':');
  const date = new Date();
  date.setHours(Number(splitedTime[0]));
  date.setMinutes(Number(splitedTime[1]));
  date.setTime(date.getTime() + offset);
  return formatDateToTime(date);
};

export const addMinutes = (date: string, duration: number) => {
  const endTime = new Date(new Date(date).getTime() + duration * 60000);

  return formatDateToTime(endTime);
};
